// @core/api/endpoints/payment/update_bank_requisites.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateBankRequisitesRequest,
  UpdateBankRequisitesResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Update bank account requisites on a payment method
 * Sets or updates the BankAccountRequisites sub-message on a PaymentMethodDetail. Only valid when the method's type == BANK_ACCOUNT. Uses FieldMask so callers can update individual fields (e.g. only correspondent_account or swift_bic) without re-submitting the whole block. Emits payment.bank_requisites_updated for downstream contract-rendering invalidation.
 */
export async function UpdateBankRequisites(
  paymentMethodId: string,
  data: UpdateBankRequisitesRequest,
  options?: RequestOptions
): Promise<UpdateBankRequisitesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payment-methods/:paymentMethodId/bank-requisites`;
  requestPath = requestPath.replace(':paymentMethodId', encodeURIComponent(paymentMethodId));
  const requestOptions = options;
  return client.patch<UpdateBankRequisitesResponse>(requestPath, data, requestOptions);
}
